
/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/


/**
 * AUTO-GENERATED FILE. DO NOT MODIFY.
 */

/*
* Licensed to the Apache Software Foundation (ASF) under one
* or more contributor license agreements.  See the NOTICE file
* distributed with this work for additional information
* regarding copyright ownership.  The ASF licenses this file
* to you under the Apache License, Version 2.0 (the
* "License"); you may not use this file except in compliance
* with the License.  You may obtain a copy of the License at
*
*   http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing,
* software distributed under the License is distributed on an
* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
* KIND, either express or implied.  See the License for the
* specific language governing permissions and limitations
* under the License.
*/
;
var _impl = null;
export function registerScaleBreakHelperImpl(impl) {
  if (!_impl) {
    _impl = impl;
  }
}
export function getScaleBreakHelper() {
  return _impl;
}
export function simplyParseBreakOption(scale, opt) {
  var scaleBreakHelper = getScaleBreakHelper();
  var breakOption = opt.breakOption;
  var breakParsed = opt.breakParsed;
  if (!breakParsed && scaleBreakHelper) {
    breakParsed = scaleBreakHelper.parseAxisBreakOption(breakOption, scale);
  }
  return breakParsed;
}
export function getBreaksUnsafe(scale) {
  var brk = scale.brk;
  return brk ? brk.breaks : [];
}
export function hasBreaks(scale) {
  var brk = scale.brk;
  return brk ? brk.hasBreaks() : false;
}


//////////////////
// WEBPACK FOOTER
// ./~/echarts/lib/scale/break.js
// module id = 85
// module chunks = 1